/* Quick product-card previews. Normal taps on artwork and titles still open the PDP. */
(function () {
  /* Anchor each heart to the VISIBLE image, not the outer ivory card.
     A 'contain' scenic picture has a different visible box from a portrait.
     Measuring it after each swipe fixes both positions without altering
     Abibo's saved state or native wishlist click listeners. */
  function alignHeart(card) {
    if (!card || !card.classList.contains('jjl-preview-cosmetics')) return;
    var media = card.querySelector('.product-card__media');
    if (!media) return;
    var img = media.querySelector('img[data-jjl-card-slide].is-active') ||
              media.querySelector('img[data-jjl-card-featured]');
    if (!img || !img.naturalWidth || !img.naturalHeight) return;
    var box = media.getBoundingClientRect();
    if (!box.width || !box.height) return;
    var imgStyle = window.getComputedStyle(img);
    var cover = imgStyle.objectFit === 'cover';
    var fittedW = box.width, fittedH = box.height;
    if (!cover) {
      var factor = Math.min(box.width / img.naturalWidth, box.height / img.naturalHeight);
      fittedW = img.naturalWidth * factor;
      fittedH = img.naturalHeight * factor;
    }
    var visibleTop = Math.max(4, (box.height - fittedH) / 2 + 5);
    var visibleRight = Math.max(4, (box.width - fittedW) / 2 + 5);
    media.style.setProperty('--jjl-image-heart-top', visibleTop.toFixed(1) + 'px');
    media.style.setProperty('--jjl-image-heart-right', visibleRight.toFixed(1) + 'px');
    var cardBox = card.getBoundingClientRect();
    card.style.setProperty('--jjl-card-heart-top', (box.top - cardBox.top + visibleTop).toFixed(1) + 'px');
    card.style.setProperty('--jjl-card-heart-right', (cardBox.right - box.right + visibleRight).toFixed(1) + 'px');
  }
  function refreshHearts(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.product-card.jjl-preview-cosmetics').forEach(function(card){
      alignHeart(card);
    });
  }
  function init(root) {
    var galleries = root.querySelectorAll ? root.querySelectorAll('.jjl-card-gallery__media') : [];
    galleries.forEach(function (media) {
      if (media.dataset.jjlGalleryReady === 'true') return;
      var link = media.querySelector('[data-jjl-card-gallery]');
      var slides = Array.prototype.slice.call(media.querySelectorAll('[data-jjl-card-slide]'));
      var card = media.closest('.product-card');
      var dots = card ? Array.prototype.slice.call(card.querySelectorAll('[data-jjl-card-dot]')) : [];
      if (!link || slides.length < 2 || dots.length < 2) return;
      media.dataset.jjlGalleryReady = 'true';
      var index = 0, startX = 0, startY = 0, swipeUntil = 0;
      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
          dot.setAttribute('aria-pressed', i === index ? 'true' : 'false');
        });
        window.requestAnimationFrame(function(){ alignHeart(card); });
      }
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (event) {
          event.preventDefault(); event.stopPropagation(); show(i);
        });
      });
      link.addEventListener('touchstart', function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive:true });
      link.addEventListener('touchend', function (event) {
        if (!event.changedTouches || !event.changedTouches[0]) return;
        var dx = event.changedTouches[0].clientX - startX;
        var dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          swipeUntil = Date.now() + 850;
          show(index + (dx < 0 ? 1 : -1));
        }
      }, { passive:true });
      link.addEventListener('click', function (event) {
        if (Date.now() < swipeUntil) {
          event.preventDefault(); event.stopImmediatePropagation();
        }
      }, true);
      slides.forEach(function(slide){ slide.addEventListener('load', function(){ alignHeart(card); }); });
      show(0);
    });
  }
  function ready() {
    init(document);
    refreshHearts(document);
    window.addEventListener('resize', function(){ window.requestAnimationFrame(function(){ refreshHearts(document); }); });
    window.setTimeout(function(){ refreshHearts(document); }, 650);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) { init(document); refreshHearts(document); break; }
      }
    });
    observer.observe(document.getElementById('MainContent') || document.body,
      { childList:true, subtree:true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();